import { PageHeader } from "@/components/kit";
import { AccessSheet, AccessPermissions } from "@/components/Accesses";
import { PROFILES } from "@/data/mock";

export default function OwnerAccess() {
  const cid = PROFILES.empresaria.companyId;
  return (
    <div data-testid="owner-access-page">
      <PageHeader eyebrow="Acessos" title="Logins e senhas da empresa" subtitle="Tudo em um só lugar: Wi-Fi, computadores, sistemas, alarmes e redes sociais." />
      <div className="grid grid-cols-1 gap-6 xl:grid-cols-3">
        <div className="xl:col-span-2"><AccessSheet companyId={cid} editable /></div>
        <AccessPermissions companyId={cid} />
      </div>
    </div>
  );
}
